import React from "react";

export default function FormatDate(date) {
    const formattedDate = new Date(date).toLocaleString();
    return <div>{formattedDate}</div>;
}
